export const DetailScreensRequestModel = {

  arrangementNumber: '',
  administrationCode: '',
  iban: '',
  bankCode: '',
  commercialProductTypeCode: '',
  relationRestrictedDataView: '',
  restrictedDataViewException: '',
  relationMarketSegmentCode: '',
};
